// extracted by mini-css-extract-plugin
module.exports = {"container":"layout_container__3XA8L"};